import { render, staticRenderFns } from "./icon-arrow-bread-crumbs.vue?vue&type=template&id=307211c5"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports